export default {
    ObtenerVehiculos(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerVehiculos`).then(response => {
            vm.vehiculos = response.data;
            //console.log(vm.vehiculos[0]);
        })
    },
    obtenerConductor(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerConductor`).then(response => {
            vm.conductores = response.data;
        })
    },
    obtenerAsistencia(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerAsistencia`).then(response => {
            vm.asistencia = response.data;
        })
    },
    obtenerAsuntosRelevantes(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerAsuntosRelevantes`).then(response => {
            vm.asuntosrelevantes = response.data;

            for (let item in vm.asuntosrelevantes) {
                vm.total += vm.asuntosrelevantes[item]["proceso"];
                if (vm.asuntosrelevantes[item]["descripcion"] == "Lesiones-Hospitalización")
                    vm.asuntosrelevantes[item]["descripcion"] = "Lesiones-Hospit.";
            }

        })
    },
    ObtenerNotificacionVehiculo(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/NotificacionesVehiculo`).then(response => {
            vm.datos = response.data;
        })
    },
    ObtenerTurnadoColisiones(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerTurnadoColisiones`, data).then(response => response.data);
    },
    ObtenerTurnadoRobos(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerTurnadoRobos`, data).then(response => response.data);
    },
    ObtenerPendientesColisiones(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesColisiones`, data).then(response => response.data);
    },
    ObtenerPendientesRobos(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesRobos`, data).then(response => response.data);
    },
    ObtenerVhDetenidos(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerVhDetenidos`, data).then(response => response.data);
    },
    ObtenerRLV(vm, data) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerRLV`, data).then(response => response.data);
    },
    DashboardPerfil(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/DashboardPerfil`).then(response => response.data);
    },
    obtenerFlotillas(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerFlotilla`).then(response => {
            vm.flotillas = response.data;
            vm.flotillasTemp = [...vm.flotillas];
        })
    },
    async ObtenerPendientesColisionesRobosExcel(vm, data) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesColisionesRobosExcel`, data)
        return response.data
    },
    async ObtenerPendientesColisionesExcel(vm, data) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesColisionesExcel`, data)
        return response.data
    },
    async ObtenerPendientesRobosExcel(vm, data) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesRobosExcel`, data)
        return response.data
    },
    async ObtenerVhDetenidosExcel(vm, data) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerVhDetenidosExcel`, data)
        return response.data
    },
    async ObtenerRLVExcel(vm, data) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerRLVExcel`, data)
        return response.data
    },
};